import React from 'react';
import { FormattedMessage } from 'react-intl';
import MikaCard from '../../components/MikaCard/MikaCard';

interface CanceledProductCardGridProps {
    data: any[];
}

const getInitials = (name: string): string => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    return (parts[0]?.charAt(0) + (parts[1]?.charAt(0) || '')).toUpperCase();
};

const getAvatarColor = (name: string): string => {
    const colors = ['#ef4444', '#f59e0b', '#8b5cf6', '#06b6d4', '#3b82f6', '#22c55e', '#ec4899', '#6366f1'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
};

const CanceledProductCardGrid: React.FC<CanceledProductCardGridProps> = ({ data }) => {
    return (
        <div className="ccg-grid">
            {data.length === 0 ? (
                <div className="ccg-empty">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
                        <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                    </svg>
                    <p><FormattedMessage id="offer.canceled.noCanceledFound" defaultMessage="No canceled products found" /></p>
                </div>
            ) : (
                data.map((product) => {
                    const clientName = product.client?.name || '\u2014';
                    const initials = getInitials(clientName);
                    const avatarColor = getAvatarColor(clientName);

                    return (
                        <MikaCard
                            key={product.id}
                            header={
                                <div className="ccg-card-header">
                                    <div className="ccg-avatar" style={{ background: avatarColor }}>
                                        {initials}
                                    </div>
                                    <div className="ccg-card-name">
                                        <span className="ccg-name">{product.article?.name || '\u2014'}</span>
                                        <span className="ccg-company">{clientName}</span>
                                    </div>
                                    <span className="ccg-status-badge" style={{ color: '#ef4444', background: '#fef2f2' }}>
                                        <FormattedMessage id="offer.canceled.badge" defaultMessage="Canceled" />
                                    </span>
                                </div>
                            }
                            body={
                                <div className="ccg-card-body-content">
                                    <div className="ccg-info-grid">
                                        <div className="ccg-info-item">
                                            <span className="ccg-info-label"><FormattedMessage id="offer.list.column.client" defaultMessage="Client" /></span>
                                            <span className="ccg-info-value">{clientName}</span>
                                        </div>
                                        <div className="ccg-info-item">
                                            <span className="ccg-info-label"><FormattedMessage id="offer.list.column.project" defaultMessage="Project" /></span>
                                            <span className="ccg-info-value">{product.project?.name || '\u2014'}</span>
                                        </div>
                                        <div className="ccg-info-item">
                                            <span className="ccg-info-label"><FormattedMessage id="offer.list.column.product" defaultMessage="Product" /></span>
                                            <span className="ccg-info-value">{product.article?.name || '\u2014'}</span>
                                        </div>
                                        <div className="ccg-info-item">
                                            <span className="ccg-info-label"><FormattedMessage id="offer.list.column.quantity" defaultMessage="Quantity" /></span>
                                            <span className="ccg-info-value">
                                                {product.quantity != null
                                                    ? <span style={{ color: '#1e40af', fontWeight: 600 }}>{product.quantity}</span>
                                                    : '\u2014'
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                            footer={
                                <div className="ccg-card-footer">
                                    <span className="ccg-date">
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
                                        </svg>
                                        #{product.id}
                                    </span>
                                </div>
                            }
                        />
                    );
                })
            )}
        </div>
    );
};

export default CanceledProductCardGrid;
